module.exports = "<p>\r\n  pre-contratos works!\r\n</p>\r\n"